import { useEffect, useState } from "react";
import { Nullable } from "../Types/Common";
import { user } from "../utils/Constant";
import { IUser } from "../features/login/types";

const useUser = () => {
  const [userDetails, setUserDetials] = useState<Nullable<IUser>>(null);

  useEffect(() => {
    const storedUser = localStorage.getItem(user);

    if (storedUser) {
      setUserDetials(JSON.parse(storedUser));
    }
  }, []);

  return userDetails;
};

export default useUser;
